import { render, staticRenderFns } from "./SmartTrashManagerInfo.vue?vue&type=template&id=67b873dc"
import script from "./SmartTrashManagerInfo.vue?vue&type=script&lang=js"
export * from "./SmartTrashManagerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports